var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransparencyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 118,
    height: 108,
    viewBox: "0 0 118 108",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.9838 1.66602C21.5321 1.66602 1.66016 21.6269 1.66016 46.2354C1.66016 55.6919 4.60614 64.4231 9.58753 71.6498L3.61522 86.1033C2.89211 87.8227 4.63292 89.5421 6.32016 88.8167L20.4877 82.6914C27.6919 87.7958 36.4495 90.8316 45.9302 90.8316C70.3819 90.8316 90.2271 70.8708 90.2271 46.2622C90.2271 21.6537 70.4355 1.69288 45.957 1.69288H45.9838V1.66602Z",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4506 30.5723C107.877 37.3154 116.34 50.5331 116.34 65.7119C116.34 74.1745 113.689 81.9922 109.216 88.4399L114.573 101.362C115.215 102.893 113.662 104.425 112.162 103.78L99.4143 98.2994C92.9599 102.867 85.0861 105.58 76.5963 105.58C68.1065 105.58 59.5364 102.652 52.8945 97.7084",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3164 53.193L41.0291 62.3271L57.1249 40.7812",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransparencyIcon);
export default __webpack_public_path__ + "static/media/transparency-icon.26b4ff1d.svg";
export { ForwardRef as ReactComponent };